export class WordEntry {
    public reading: string;
    public glossary: string[];
    public sourceLanguage?: string;
    public sourceTerm?: string;
    public frequency?: number;
    public array_Agg?: string;
    public kanji?: string;
}


// WEBPACK FOOTER //
// ./src/WordEntry.ts